import type { BoxProps } from '@mantine/core';
import { Box } from '@mantine/core';

import { getSx } from '../utils/sx';

interface TextSeparatorProps extends BoxProps {
  color?: string;
}

export function TextSeparator({
  sx = {},
  color = '#D9D9D9',
  ...props
}: TextSeparatorProps) {
  return (
    <Box
      bg={color}
      h={4}
      w={4}
      {...props}
      styles={[{ borderRadius: '100%' }, ...getSx(sx)]}
    />
  );
}
